export enum CopDocumentType {
  CC = 'CC',
  CE = 'CE',
  NIT = 'NIT',
  PASS = 'PASS',
  PEP = 'PEP',
  UNSET = '',
}
